const INCLUDE_MILITARY_FEATURES = window.env.REACT_APP_INCLUDE_MILITARY_FEATURES ==="true";

export const CoordinateUnits = Object.freeze({
    LAT_LON_DD: 'LAT_LON_DD',
    ...INCLUDE_MILITARY_FEATURES && {MGRS: 'MGRS'}
});

export const WindDirectionUnits = Object.freeze({
    DEGREES: 'DEGREES',
    ...INCLUDE_MILITARY_FEATURES && {MILS: 'MILS'}
});

export const DateFormats = Object.freeze({
    ISO: 'ISO',
    ...INCLUDE_MILITARY_FEATURES && {MIL_DATE_TIME_GROUP: 'MIL_DATE_TIME_GROUP'}
});
